<template>
    <div class="post-wrapper conversation card card-shadow group-topic" :class="{'compact': compact, 'unread' : topic.unread, 'single-topic': singleTopic}">

        <topic-scroll-to-newest :singleTopic="singleTopic" :itemHighlighted="itemHighlighted" :topic="topic" :viewType="viewType"></topic-scroll-to-newest>

        <topic-helpdesk-status-switch :topic="topic"></topic-helpdesk-status-switch>

        <moodview-topic-top :topic="topic" :viewType="viewType"></moodview-topic-top>

        <!-- post top -->
        <!--<div class="post-top" v-if="topic.status == 'invisible' && topic.user().id == user.id">-->
        <div class="post-top">
            <div v-if="isUsersInvisibleIntroductionTopic" class="user-visible">
                {{ translations['introduce.visible'] }}
            </div>
            <div class="card-inner flex group-bg-image tw-relative">
                <div class="bg-image" v-if="!compact">
                    <img :src="topic.group.image">
                </div>
                <div class="flex-1 flex-no-padding">
                    <topic-user-icon :topic="topic"></topic-user-icon>
                </div>
                <div class="flex-16 flex-no-padding">
                    <div class="post-top-content">
                        <a :href="'/groups/' + topic.group.slug" class="tw-relative tw-text-xs tw-mb-1 tw-flex tw-items-center tw-opacity-75 hover:tw-underline" :class="{'extra-light-text': !compact}">
                            <i class="far fa-users tw-mr-2"></i>
                            {{ topic.group.name }}
                        </a>
                        <topic-top-meta :topic="topic" :viewType="viewType" :singleTopic="singleTopic"></topic-top-meta>
                    </div>
                </div>
            </div>
            <div class="post-top-content" v-if="!compact">
                <topic-content :topic="topic" :viewType="viewType" :expandedTopic="expandedTopic"></topic-content>
            </div>
        </div>

        <!-- post likes & comments count -->
        <topic-stats :topic="topic" :displayMode="displayMode" :showViewsCount="showViewsCount" :likeIcon="showLikeIcon"></topic-stats>

        <!-- post comments -->
        <comments :topic="topic" v-if="!isUsersInvisibleIntroductionTopic" :viewType="viewType" :focusCommentByHashId="focusCommentByHashId" :singleTopic="singleTopic"></comments>

        <div class="align-center card-inner background-lightblue" style="border-radius: 0 0 3px 3px;" v-else>
            <div class="general-button inline-button" @click="initEditTopic(topic, true)">{{ translations['introduce.introduce'] }}</div>
        </div>
    </div>
</template>

<script>
    //mixins
    import {mapState} from 'vuex';
    import Feed from '../../mixins/Feed.js'
    import Global from '../../mixins/Global.js'
    import Topic from '../../mixins/Topic.js'

    export default {
        mixins: [Feed, Global, Topic],
        name: 'Topic',

        computed: {
            ...mapState([
                'displayMode',
                'plugins'
            ]),

            compact() {
                return this.displayMode === 'small' && !isHelpdesk;
            },
        },

        data() {
            return {
                isHelpdesk: isHelpdesk,
            };
        },
    };
</script>

<style lang="scss">
    @import '../../../../../assets/sass/fakebook/_mixins.scss';

    .group-topic {
        .group-bg-image {
            @apply tw-px-6 tw-py-4 tw-rounded;

            .bg-image {
                @include better-blur(5);
                @apply tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full tw-overflow-hidden tw-object-cover;

                img {
                  @apply tw-w-full;
                }

                &:before {
                    @apply tw-absolute tw-top-0 tw-left-0 tw-right-0 tw-bottom-0 tw-bg-black;
                    content: '';
                    opacity: 0.4;
                }
            }

            .post-top-content {
                margin-left: 25px !important;
                padding: 0 !important;
            }
        }

        .post-top {
            .post-top-content {
                margin-left: 97px;
                padding-top: 17px;
                padding-bottom: 17px;

                .post-top-content-name {
                    @apply tw-mb-0;

                    a {
                        @apply tw-relative;
                        margin-right: 5px;

                        .profile-name {
                            color: #c7c7c7;
                            font-weight: 400;
                        }
                    }
                }

                .post-content {
                    @apply tw-inline-block;
                    padding-bottom: 8px;
                }
            }
        }

        .post-media-mobile-toggle {
            margin-top: -8px;
            margin-right: 0;
        }

        .post-media {
            right: -3px;
        }

        /*.topic-read-more {
            margin-left: 72px;
            margin-bottom: 10px;
            display: inline-block;
        }*/

        &:not(.compact) {
            @apply tw-overflow-hidden;

            .post-top {
                .post-top-content {
                    .post-top-content-title {
                        .post-title {
                            @apply tw-text-white #{!important};
                            opacity: 0.8;
                        }
                    }
                }
            }
        }

        &.unread {
            .post-top {
                .post-top-content {
                    .post-top-content-title {
                        .post-title {
                            opacity: 1;
                        }
                    }
                }
            }
        }
    }
</style>
